import styled from '@emotion/styled';

export const Conteiner = styled.div`
  display: flex;
  padding: 0 8px;
  border-right: 1px solid #e0e5eb;
`;
export const LinkStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 33px;
  height: 33px;
  transition-duration: 500ms;
  fill: #a6abb9;
  :hover {
    transform: scale(1.2);
  }
`;
